import { useEffect, useState } from 'react';
import { useCurrentUser } from '@hotjar/user';
import { optimizely } from './optimizely';

export const useOptimizelyFeatureForUser = (featureId: string): boolean => {
  const [isActive, setActiveState] = useState(false);
  const { data: currentUser } = useCurrentUser();

  useEffect(() => {
    if (!currentUser) return;
    optimizely
      .isFeatureEnabled(featureId, `${currentUser.id}`, {
        has_hotjar_email: currentUser.email?.endsWith('@hotjar.com') ?? false,
        email: currentUser.email,
      })
      .then((result) => setActiveState(result))
      .catch(() => setActiveState(false));
  }, [currentUser, featureId]);

  return isActive;
};
